import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SortIcon, TableModule } from 'primeng/table';
import { IntranetSeguridadService } from '../../../../core/services/intranet-seguridad.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { AlertaService } from '../../../../core/services/alerta.service';
import { environment } from '../../../../../environments/environment';

declare const google: any;

export type ReporteKey = 'solicitudes' | 'valoraciones' | 'usuarios' | 'vehiculos';
type Item = any;

@Component({ selector: 'app-reporte-solicitudes-page', templateUrl: './solicitudes.component.html', styleUrl: './solicitudes.component.scss', imports: [CommonModule, FormsModule, ButtonModule, DialogModule, InputTextModule, TableModule, SortIcon] })
export class ReporteSolicitudesComponent implements OnInit {
  @ViewChild('solicitudMap') solicitudMap?: ElementRef<HTMLDivElement>;
  @Input() reporteKey: ReporteKey = 'solicitudes';
  key!: ReporteKey;
  titulo = '';
  columns: Array<{ key: string; label: string }> = [];
  items: Item[] = [];
  private todosLosItems: Item[] = [];
  filtro = { texto: '', estado: null as number | null, tipoSolicitud: '', fechaInicio: '', fechaFin: '' };
  busquedaRapida = '';
  filtroLocal = { fechaInicio: '', fechaFin: '', pais: '', estado: '', marca: '', modelo: '', tipo: '', visible: '', ordenar: '' };
  imagenes: Item[] = [];
  tituloImagenes = 'Imágenes de la solicitud';
  visibleImagenes = false;
  imagenSeleccionada = '';
  visibleImagenZoom = false;
  visibleDetalle = false;
  detalle: Item | null = null;
  visibleMapaSolicitud = false;
  tituloMapaSolicitud = '';
  ubicacionConductor: { latitud: number; longitud: number } | null = null;
  private mapaSolicitudItem: Item | null = null;
  private mapaIncluyeConductor = false;
  private googleMapsReady?: Promise<void>;
  visibleAccionesSolicitud = false;
  solicitudAcciones: Item | null = null;
  usuarioClave: Item | null = null;
  visibleCambioClave = false;
  nuevaClave = '';

  constructor(private readonly seguridad: IntranetSeguridadService, private readonly loading: LoadingService, private readonly alerta: AlertaService, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.key = this.reporteKey;
    const config: Record<ReporteKey, [string, Array<{ key: string; label: string }>]> = {
      solicitudes: ['Solicitudes', [{ key: 'IdSolicitud', label: 'Solicitud' }, { key: 'TipoSolicitud', label: 'Tipo de solicitud' }, { key: 'Estado', label: 'Estado' }, { key: 'TipoVehiculo', label: 'Vehículo' }, { key: 'Cliente', label: 'Cliente' }, { key: 'Propietario', label: 'Propietario' }, { key: 'Conductor', label: 'Conductor' }, { key: 'EtapaViaje', label: 'Etapa' }, { key: 'FechaTrabajo', label: 'Fecha' }]],
      valoraciones: ['Valoraciones', [{ key: 'IdSolicitud', label: 'Solicitud' }, { key: 'UsuarioValorador', label: 'Valorador' }, { key: 'UsuarioValorado', label: 'Valorizado' }, { key: 'Valor', label: 'Puntaje' }, { key: 'Comentario', label: 'Comentario' }, { key: 'FechaCreacion', label: 'Fecha' }]],
      usuarios: ['Usuarios del aplicativo', [{ key: 'Pais', label: 'País' }, { key: 'Nombres', label: 'Nombres' }, { key: 'Apellidos', label: 'Apellidos' }, { key: 'CorreoElectronico', label: 'Correo' }, { key: 'Telefono', label: 'Teléfono' }, { key: 'Dni', label: 'DNI' }, { key: 'Saldo', label: 'Saldo' }, { key: 'Valoracion', label: 'Valoración' }, { key: 'FechaNacimiento', label: 'Nacimiento' }, { key: 'FechaCreacion', label: 'Registro' }, { key: 'Activo', label: 'Estado' }]],
      vehiculos: ['Vehículos', [{ key: 'IdVehiculo', label: 'ID' }, { key: 'TipoVehiculo', label: 'Tipo' }, { key: 'Marca', label: 'Marca' }, { key: 'Modelo', label: 'Modelo' }, { key: 'Placa', label: 'Placa' }, { key: 'Propietario', label: 'Propietario' }, { key: 'Visible', label: 'Visible' }]],
    };
    [this.titulo, this.columns] = config[this.key];
    this.cargar();
  }

  cargar(): void {
    this.loading.open('Cargando reporte...');
    const payload = this.key === 'solicitudes' ? this.filtro : {};
    this.seguridad.post<Item[]>(`reportes/${this.key}/listar`, payload).subscribe({
      next: (r) => { this.loading.close(); this.todosLosItems = r.isSuccess ? r.value ?? [] : []; this.aplicarBusqueda(); if (!r.isSuccess) this.alerta.openAlerta('Alerta', r.message, 'error'); this.cdr.detectChanges(); },
      error: (e) => { this.loading.close(); this.items = []; this.cdr.detectChanges(); this.alerta.openAlerta('Error', e?.message ?? 'No se pudo cargar el reporte', 'error'); },
    });
  }

  estadoSolicitud(estado: number): string { return ({ 1: 'Enviada', 2: 'Rechazada', 3: 'Enviada a conductor', 4: 'Aceptada', 5: 'Finalizada', 6: 'Cancelada', 7: 'Rechazada por conductor' } as Record<number, string>)[Number(estado)] ?? 'Sin estado'; }
  etapaViaje(etapa: number): string { return ({ 1: 'Yendo al tráiler', 2: 'Tráiler recogido', 3: 'Yendo a carga', 4: 'Viaje iniciado', 5: 'En ruta al destino', 6: 'Viaje completado' } as Record<number, string>)[Number(etapa)] ?? '-'; }
  ubicacionActual(item: Item): string { return item.LatitudActual && item.LongitudActual ? `${item.LatitudActual}, ${item.LongitudActual}` : '-'; }
  estadoUsuario(activo: number): string { return Number(activo) === 1 ? 'Activo' : 'Inactivo'; }
  esFechaTabla(campo: string): boolean { return ['FechaNacimiento', 'FechaCreacion', 'FechaTrabajo'].includes(campo); }
  formatearFecha(valor: unknown, incluirHora: boolean): string {
    if (!valor) return '-';
    const coincidencia = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (!coincidencia) return String(valor);
    const [, anio, mes, dia, hora = '0', minuto = '0', segundo = '0'] = coincidencia;
    const fecha = new Date(Number(anio), Number(mes) - 1, Number(dia), Number(hora), Number(minuto), Number(segundo));
    return new Intl.DateTimeFormat('es-PE', incluirHora ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' }).format(fecha);
  }

  aplicarBusqueda(): void {
    const termino = this.busquedaRapida.trim().toLocaleLowerCase();
    let resultado = !termino ? [...this.todosLosItems] : this.todosLosItems.filter((item) => JSON.stringify(item).toLocaleLowerCase().includes(termino));
    const f = this.filtroLocal;
    if (this.key === 'valoraciones' && (f.fechaInicio || f.fechaFin)) resultado = resultado.filter((i) => this.entreFechas(i.FechaCreacion, f.fechaInicio, f.fechaFin));
    if (this.key === 'usuarios') {
      if (f.pais) resultado = resultado.filter((i) => String(i.IdPais) === f.pais);
      if (f.estado) resultado = resultado.filter((i) => String(i.Activo) === f.estado);
      if (f.fechaInicio || f.fechaFin) resultado = resultado.filter((i) => this.entreFechas(i.FechaNacimiento, f.fechaInicio, f.fechaFin));
      if (f.ordenar) resultado.sort((a, b) => f.ordenar === 'saldo-desc' ? Number(b.Saldo) - Number(a.Saldo) : f.ordenar === 'saldo-asc' ? Number(a.Saldo) - Number(b.Saldo) : String(a.Nombres).localeCompare(String(b.Nombres)) * (f.ordenar === 'nombre-desc' ? -1 : 1));
    }
    if (this.key === 'vehiculos') {
      if (f.marca) resultado = resultado.filter((i) => String(i.Marca).toLowerCase().includes(f.marca.toLowerCase()));
      if (f.modelo) resultado = resultado.filter((i) => String(i.Modelo).toLowerCase().includes(f.modelo.toLowerCase()));
      if (f.tipo) resultado = resultado.filter((i) => i.TipoVehiculo === f.tipo);
      if (f.visible) resultado = resultado.filter((i) => String(i.Visible) === f.visible);
    }
    this.items = resultado;
  }

  private entreFechas(valor: string, inicio: string, fin: string): boolean { const fecha = String(valor ?? '').slice(0, 10); return (!inicio || fecha >= inicio) && (!fin || fecha <= fin); }
  paises(): Item[] { return [...new Map(this.todosLosItems.map((i) => [i.IdPais, i])).values()]; }
  tiposVehiculo(): string[] { return [...new Set(this.todosLosItems.map((i) => i.TipoVehiculo).filter(Boolean))]; }
  visibleVehiculo(item: Item): string { return Number(item.Visible) === 1 ? 'Sí' : 'No'; }
  esUsuarioActivo(item: Item): boolean { return Number(item.Activo) === 1; }
  esVehiculoVisible(item: Item): boolean { return Number(item.Visible) === 1; }
  claseEstadoSolicitud(estado: number): string { return [2, 6, 7].includes(Number(estado)) ? 'status-pill--danger' : Number(estado) === 5 ? 'status-pill--info' : 'status-pill--success'; }

  verRuta(item: Item): void { this.abrirMapaSolicitud(item, false); }

  solicitudEnCurso(item: Item): boolean { return Number(item.Estado) === 4; }
  verSeguimiento(item: Item): void {
    if (item.LatitudActual === null || item.LatitudActual === undefined || item.LongitudActual === null || item.LongitudActual === undefined) {
      this.alerta.openAlerta('Seguimiento', 'El conductor todavía no ha compartido una ubicación.', 'info');
      return;
    }
    this.abrirMapaSolicitud(item, true);
  }

  abrirAccionesSolicitud(item: Item): void { this.solicitudAcciones = item; this.visibleAccionesSolicitud = true; }
  ejecutarAccionSolicitud(accion: 'aceptar' | 'cancelar' | 'finalizar' | 'eliminar'): void {
    const solicitud = this.solicitudAcciones;
    if (!solicitud?.IdSolicitud) return;
    const etiquetas = { aceptar: 'aceptar', cancelar: 'cancelar', finalizar: 'finalizar', eliminar: 'eliminar' };
    this.alerta.openAlertaDesicion('Confirmar acción', `¿Deseas ${etiquetas[accion]} la solicitud #${solicitud.IdSolicitud}?`, accion === 'eliminar' || accion === 'cancelar' ? 'warn' : 'info', () => {
      this.loading.open('Actualizando solicitud...');
      this.seguridad.post('reportes/solicitudes/accion', { idSolicitud: solicitud.IdSolicitud, accion }).subscribe({
        next: (respuesta) => {
          this.loading.close();
          if (respuesta.isSuccess) {
            this.visibleAccionesSolicitud = false;
            this.alerta.openAlerta('Correcto', respuesta.message, 'success');
            this.cargar();
          } else this.alerta.openAlerta('Alerta', respuesta.message, 'error');
          this.cdr.detectChanges();
        },
        error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo actualizar la solicitud', 'error'); },
      });
    });
  }

  verImagenes(item: Item): void {
    this.loading.open('Cargando imágenes...');
    this.seguridad.post<Item[]>('reportes/vehiculos/imagenes', { idVehiculo: item.IdVehiculo }).subscribe({
      next: (r) => { this.loading.close(); this.tituloImagenes = 'Imágenes del vehículo'; this.imagenes = r.value ?? []; this.visibleImagenes = true; this.cdr.detectChanges(); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudieron cargar las imágenes', 'error'); },
    });
  }

  verImagenesSolicitud(item: Item): void {
    this.loading.open('Cargando imágenes de la solicitud...');
    this.seguridad.post<Item[]>('reportes/solicitudes/imagenes', { idSolicitud: item.IdSolicitud }).subscribe({
      next: (r) => { this.loading.close(); this.tituloImagenes = 'Imágenes de la solicitud'; this.imagenes = r.value ?? []; this.visibleImagenes = true; this.cdr.detectChanges(); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudieron cargar las imágenes de la solicitud', 'error'); },
    });
  }

  verDetalle(item: Item): void {
    const endpoint = this.key === 'solicitudes' ? 'reportes/solicitudes/detalle' : this.key === 'vehiculos' ? 'reportes/vehiculos/detalle' : 'reportes/usuarios/detalle';
    const payload = this.key === 'solicitudes' ? { idSolicitud: item.IdSolicitud } : this.key === 'vehiculos' ? { idVehiculo: item.IdVehiculo } : { idUsuario: item.IdUsuario };
    this.loading.open('Cargando detalle...');
    this.seguridad.post<Item>(endpoint, payload).subscribe({
      next: (r) => { this.loading.close(); if (r.isSuccess) { this.detalle = r.value; this.visibleDetalle = true; this.cdr.detectChanges(); } else this.alerta.openAlerta('Alerta', r.message, 'error'); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo cargar el detalle', 'error'); },
    });
  }

  abrirImagen(url: string): void { this.imagenSeleccionada = url; this.visibleImagenZoom = true; this.cdr.detectChanges(); }
  abrirDocumento(url: unknown): void { if (url) window.open(String(url), '_blank', 'noopener'); }
  verMapaDetalle(): void {
    const latitud = this.detalle?.Latitud;
    const longitud = this.detalle?.Longitud;
    if (latitud !== null && latitud !== undefined && longitud !== null && longitud !== undefined) window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${latitud},${longitud}`)}`, '_blank', 'noopener');
  }
  esSolicitudTrailer(): boolean { return this.key === 'solicitudes' && String(this.detalle?.TipoSolicitud ?? '').toUpperCase() === 'TRAILER'; }
  esSolicitudMaquinaria(): boolean { return this.key === 'solicitudes' && !this.esSolicitudTrailer(); }
  verRutaDetalle(): void { if (this.detalle) this.abrirMapaSolicitud(this.detalle, false); }
  verMapaSolicitudDetalle(): void { if (this.detalle) this.abrirMapaSolicitud(this.detalle, false); }
  abrirCambioClave(item: Item): void { this.usuarioClave = item; this.nuevaClave = ''; this.visibleCambioClave = true; }
  guardarCambioClave(): void {
    if (!this.usuarioClave?.IdUsuario || this.nuevaClave.trim().length < 6) { this.alerta.openAlerta('Alerta', 'La nueva contraseña debe tener al menos 6 caracteres', 'warn'); return; }
    this.loading.open('Actualizando contraseña...');
    this.seguridad.post('reportes/usuarios/cambiar-clave', { idUsuario: this.usuarioClave.IdUsuario, clave: this.nuevaClave.trim() }).subscribe({
      next: (r) => { this.loading.close(); if (r.isSuccess) { this.visibleCambioClave = false; this.alerta.openAlerta('Correcto', r.message, 'success'); } else this.alerta.openAlerta('Alerta', r.message, 'error'); this.cdr.detectChanges(); },
      error: () => { this.loading.close(); this.alerta.openAlerta('Error', 'No se pudo actualizar la contraseña', 'error'); },
    });
  }
  esDocumento(campo: string): boolean { return ['TarjetaPropiedad', 'TarjetaCirculacion', 'Soat', 'SeguroTrec'].includes(campo); }
  esFecha(campo: string): boolean { return campo.startsWith('Fecha') || campo.includes('Timestamp'); }
  etiquetaDetalle(campo: string): string {
    return ({ TipoVehiculo: 'Tipo de vehículo', TipoCarga: 'Tipo de carga', Flota: 'Flota', PrecioHora: 'Precio por hora', CargaEstimada: 'Capacidad de carga estimada', AnioFabricacion: 'Año de fabricación', TarjetaPropiedad: 'Tarjeta de propiedad', TarjetaCirculacion: 'Tarjeta de circulación', SeguroTrec: 'Seguro TREC', FechaCreacion: 'Fecha de creación', FotoPerfil: 'Foto de perfil', CorreoElectronico: 'Correo electrónico', FechaNacimiento: 'Fecha de nacimiento', CantidadValoraciones: 'Cantidad de valoraciones', ValoracionPromedio: 'Valoración promedio', TipoSolicitud: 'Tipo de solicitud' } as Record<string, string>)[campo] ?? campo.replace(/([A-Z])/g, ' $1').trim();
  }
  valorDetalle(campo: string, valor: unknown): string {
    if (campo === 'Visible') return Number(valor) === 1 ? 'Sí' : 'No';
    if (campo === 'EtapaViaje') return this.etapaViaje(Number(valor));
    if (campo === 'Estado') return this.key === 'vehiculos' ? (Number(valor) === 1 ? 'Disponible' : 'No disponible') : (Number(valor) === 1 ? 'Activo' : 'Inactivo');
    if (this.esFecha(campo)) { const fecha = new Date(String(valor)); return Number.isNaN(fecha.getTime()) ? String(valor) : new Intl.DateTimeFormat('es-PE', { dateStyle: 'medium', timeStyle: 'short' }).format(fecha); }
    return String(valor);
  }
  detalleEntries(): Array<[string, unknown]> {
    const ocultos = new Set(['Activo', 'Latitud', 'Longitud', 'IdUsuarioCreacion']);
    if (this.key === 'solicitudes') {
      ['Estado', 'DireccionFin', 'LatitudInicio', 'LongitudInicio', 'LatitudFin', 'LongitudFin', 'LatitudActual', 'LongitudActual', 'TimestampUbicacion'].forEach((campo) => ocultos.add(campo));
      if (this.esSolicitudTrailer()) ocultos.add('DireccionInicio');
    }
    return Object.entries(this.detalle ?? {}).filter(([campo, valor]) => !campo.startsWith('Id') && !ocultos.has(campo) && valor !== null && valor !== '');
  }

  private abrirMapaSolicitud(item: Item, incluirConductor: boolean): void {
    const tieneDestino = item.LatitudFin !== null && item.LatitudFin !== undefined && item.LongitudFin !== null && item.LongitudFin !== undefined;
    this.tituloMapaSolicitud = incluirConductor ? 'Seguimiento del conductor' : tieneDestino ? 'Ruta del trabajo' : 'Ubicación del trabajo';
    this.ubicacionConductor = incluirConductor ? { latitud: Number(item.LatitudActual), longitud: Number(item.LongitudActual) } : null;
    this.mapaSolicitudItem = item;
    this.mapaIncluyeConductor = incluirConductor;
    this.visibleMapaSolicitud = true;
    this.cdr.detectChanges();
    window.setTimeout(() => this.renderizarMapaSolicitud(), 0);
  }

  private async renderizarMapaSolicitud(): Promise<void> {
    if (!this.solicitudMap?.nativeElement || !this.mapaSolicitudItem) return;
    try {
      await this.cargarGoogleMaps();
      const item = this.mapaSolicitudItem;
      const inicio = { lat: Number(item.LatitudInicio), lng: Number(item.LongitudInicio) };
      const tieneDestino = item.LatitudFin !== null && item.LatitudFin !== undefined && item.LongitudFin !== null && item.LongitudFin !== undefined;
      const destino = tieneDestino ? { lat: Number(item.LatitudFin), lng: Number(item.LongitudFin) } : inicio;
      const mapa = new google.maps.Map(this.solicitudMap.nativeElement, { center: inicio, zoom: tieneDestino ? 11 : 15, mapTypeControl: false, streetViewControl: false, fullscreenControl: true });
      this.crearMarcador(mapa, inicio, 'Inicio', 'blue');
      if (tieneDestino) {
        this.crearMarcador(mapa, destino, 'Final', 'red');
        const renderer = new google.maps.DirectionsRenderer({ map: mapa, suppressMarkers: true, polylineOptions: { strokeColor: '#0B5FD5', strokeWeight: 5 } });
        new google.maps.DirectionsService().route({ origin: inicio, destination: destino, travelMode: google.maps.TravelMode.DRIVING }, (resultado: any, estado: string) => {
          if (estado === 'OK') renderer.setDirections(resultado);
        });
      }
      if (this.mapaIncluyeConductor && this.ubicacionConductor) this.crearMarcador(mapa, { lat: this.ubicacionConductor.latitud, lng: this.ubicacionConductor.longitud }, 'Conductor', 'green');
    } catch {
      this.alerta.openAlerta('Mapa', 'No se pudo cargar Google Maps. Verifica la configuración de la clave.', 'error');
      this.visibleMapaSolicitud = false;
    }
  }

  private crearMarcador(mapa: any, posicion: { lat: number; lng: number }, titulo: string, tipo: 'blue' | 'red' | 'green'): void {
    const color = { blue: '#0B5FD5', red: '#dc2626', green: '#16a34a' }[tipo];
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="68" height="78" viewBox="0 0 68 78">
      <rect x="2" y="2" width="64" height="22" rx="11" fill="#fff" stroke="${color}" stroke-width="1.5"/>
      <text x="34" y="17" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="700" fill="${color}">${titulo}</text>
      <path d="M34 27C22.4 27 13 36.4 13 48c0 15.8 21 27.6 21 27.6S55 63.8 55 48c0-11.6-9.4-21-21-21Z" fill="${color}" stroke="#fff" stroke-width="2"/>
      <circle cx="34" cy="48" r="7" fill="#fff"/>
    </svg>`;
    new google.maps.Marker({
      map: mapa,
      position: posicion,
      title: titulo,
      icon: {
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
        scaledSize: new google.maps.Size(68, 78),
        anchor: new google.maps.Point(34, 76),
      },
    });
  }

  private cargarGoogleMaps(): Promise<void> {
    if ((window as any).google?.maps) return Promise.resolve();
    if (this.googleMapsReady) return this.googleMapsReady;
    this.googleMapsReady = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAPS_API_KEY}&language=es&region=PE&v=weekly`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.head.appendChild(script);
    });
    return this.googleMapsReady;
  }
}
